<template>
  <modal @modal-close="handleClose">

    <div class="modal-wrapper create-inspection-page__dropdown-question-modal">
      <div class="modal-content">
        <div class="flex justify-end mb-4">
          <icon icon="times" size="lg" class="cursor-pointer" @click.native="handleClose" />
        </div>

        <input-field
          v-model="query"
          :placeholder="$t('Search here...')"
        />

        <div class="border-50 border rounded-lg">
          <div class="overflow-y-auto" style="max-height: 400px">

            <template v-if="multiple">
              <div
                v-for="resp in filteredResponses"
                class="flex items-start list-item px-4 py-4"
                @click.prevent="handleClick(resp.uuid)"
              >
                <checkbox-field :value="filteredResponse" :label="title(resp)" :native-value="resp.uuid" />
              </div>
            </template>
            <template v-else>
              <div
                v-for="resp in filteredResponses"
                class="flex items-center list-item px-4 py-4"
                @click.prevent="handleClick(resp.uuid)"
              >
                <radio name="answer" :native-value="resp.uuid" :value="filteredResponse">
                  {{ title(resp) }}
                </radio>
              </div>
            </template>
          </div>
        </div>

        <div v-if="showWarning" class="mt-4">
          <Icon class="mr-1 has-text-grey" icon="info-circle" icon-pack="fal" />
          {{ $t('Not all resources could be loaded. Please use search.') }}
        </div>
      </div>

      <div class="modal-actions-outer-wrapper">
        <div class="modal-actions-inner-wrapper">
          <b-button
            type="is-text no-text-decoration"
            @click.prevent="handleClose"
          >
            {{ $t('Cancel') }}
          </b-button>

          <b-button
            v-if="multiple"
            type="is-primary"
            class="modal-actions-primary"
            @click.prevent="handleSave"
          >
            {{ $t('Save') }}
          </b-button>

        </div>
      </div>

    </div>

  </modal>
</template>

<script>
  import Checkbox from '@/_legacy/components/Index/Checkbox.vue';
  import CloseButton from '@/_legacy/components/Modals/CloseButton.vue';
  import { Button as BButton } from '@/ui/components/Button';
  import { Icon } from '@/ui/components/icon/Icon';
  import { InputField } from '@/ui/components/form/InputField';
  import { Radio } from '@/ui/components/form/Radio';
  import { CheckboxField } from '@/ui/components/form/CheckboxField';
  import { getTitle } from '@/ui/helpers/formTranslationsHelper';

  export default {

    components: {
      Checkbox,
      CloseButton,
      BButton,
      Icon,
      InputField,
      Radio,
      CheckboxField,
    },

    props: {
      responses: {
        type: Array,
        required: true,
      },
      response: {
        required: true,
      },
      multiple: {
        type: Boolean,
        required: true,
      },
      limit: {
        type: Number,
        required: false,
      },
      isTranslationMode: {
        type: Boolean,
      },
    },

    data: () => ({
      temporaryResponse: [],
      query: '',
      showWarning: false,
    }),

    computed: {
      filteredResponses() {
        const query = this.query.toLowerCase().trim();
        let result = this.responses;

        if (query.length > 0) {
          result = result.filter(response => response.title.toLowerCase().indexOf(query) !== -1);
        }

        this.showWarning = this.limit && result.length > this.limit;
        return this.showWarning ? result.slice(0, this.limit) : result;
      },
      filteredResponse() {
        if (this.multiple) {
          return this.temporaryResponse;
        }

        return this.temporaryResponse ? this.temporaryResponse[0] : null;
      }
    },

    created() {
      if (this.response && this.response.length > 0) {
        this.temporaryResponse = JSON.parse(JSON.stringify(this.response));
      }
    },

    methods: {
      handleClose() {
        this.$emit('close');
      },

      handleSave() {
        this.$emit('save', this.temporaryResponse);
      },

      handleClick(value) {
        if (this.multiple) {
          const index = this.temporaryResponse.indexOf(value);
          if (index > -1) {
            this.temporaryResponse.splice(index, 1);
          } else {
            this.temporaryResponse.push(value);
          }
        } else {
          // if the user clicks on the selected item, we unselect that item
          if (this.temporaryResponse.length === 1 && this.temporaryResponse[0] === value) {
            this.temporaryResponse = [];
          } else {
            this.temporaryResponse = [value];
          }
          this.handleSave();
        }
      },

      title(response) {
        return getTitle(response, this.isTranslationMode);
      },

    },

  };
</script>
